exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-banners[data-v-f5a885b8]{background:#fff;padding:40px 20px 65px}.block-banners img[data-v-f5a885b8]{margin-bottom:20px}.caption[data-v-f5a885b8]{font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#32373f;margin-top:-10px;display:block}.price[data-v-f5a885b8]{color:#fe7397;font-weight:600;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f5a885b8","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/Products/kurenotori/partials/BannerBlock.vue
// module id = FmnL
// module chunks = 0